import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';
import Select from 'react-select';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
statisticsAction,
statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import { event } from 'jquery';
const Designation = (props) => {
const sparkline1 = React.createRef();
const sparkline2 = React.createRef();
const sparkline3 = React.createRef();
const sparkline4 = React.createRef();


const handleStatistics = (e) => {
statisticsAction(e)
}
const closeStatistics = (e) => {
statisticsCloseAction(e)
}

const { fixNavbar, statisticsOpen, statisticsClose } = props;
const emptyUser={
designation_name: "",
department_id: "",
company_id: "",
man_power: ""

}
const handleSelectChange =(sp)=>{
    setFormData({
        ...formData,
        ['company_id']: sp.company_id,

        });
console.log(formData.department_id)
  }
  const handleSelect =(sp)=>{
    setFormData({
        ...formData,
        ['department_id']: sp.value,

        });
console.log(formData.department_id)
  }
const [user, setUser] = useState({
designation_name: "",
department_id: "",
man_power: "",
company_id:"",
})

const handelInput = (event) => {
	event.preventDefault();
	const { name, value } = event.target;
	console.log(name, value)
	setUser({ ...user, [name]: value });
}



const [url_name, setUrlname] = useState('');
const [url_id, setUrlid] = useState('');
const [url_link, setUrllink] = useState('');
const [parent, setParent] = useState('');
const history = useHistory();
const [data, setData] = useState([]);
const [datacount, setDataCount] = useState([]);
const [dataval, setdataval] = useState([]);
const [currentPageId, setCurrentPageId] = useState(1);
const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);
const [table, setTable] = useState([]);
const [setcmp, setcompany] = useState([]);
const [setdept, setDept] = useState([]);

const [formData, setFormData] = useState({
designation_name: '',
department_id: '',
company_id:'',
man_power:'',

});


const handleChange = (e) => {

const { name, value } = e.target;
setFormData({
...formData,
[name]: value,
});
};
// const [anand, setAnand]= useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);
// const itemsPerPage = 10;
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
let filteredItems = table.filter((item) =>



`${item.designation_name.toLowerCase()}${item.department_name.toLowerCase()}`.includes(searchTerm.toLowerCase())

);
const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
const startIndex = (currentPage - 1) * itemsPerPage;

useEffect(() => {
setCurrentPage(1);
}, [searchTerm]);

const paginate = (pageNumber) => setCurrentPage(pageNumber);

const handleSearch = (event) => {
setSearchTerm(event.target.value);
};


const clearInput = () => {
setSearchTerm("");
};


const handleRowsPerPageChange = (e) => {
setItemsPerPage(Number(e.target.value));
setCurrentPage(1); // Reset to first page
};


useEffect(() => {

    axios
    .get(API_BASE_URL+'/all_companys', {
    headers: 
    { 
    Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
    }
    })
    .then((response) => {

    console.log(response.data.data);
    setcompany(response.data.data.all_employee);


    setLoading(false);
    })
    .catch((error) => {
    setError(error.message);
    setLoading(false);
    });
    }, []);



    useEffect(() => {

        axios
        .get(API_BASE_URL+'/all_department', {
        headers: 
        { 
        Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
        }
        })
        .then((response) => {
    
        console.log(response.data.data);
        setDept(response.data.data.all_dept);
    
    
        setLoading(false);
        })
        .catch((error) => {
        setError(error.message);
        setLoading(false);
        });
        }, []);

useEffect(() => {

	axios
	.get(API_BASE_URL+'/Designation_list', {
	headers: 
	{ 
	Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
	}
	})
	.then((response) => {
	console.log(response.data.data.holiday);
	setTable(response.data.data.Designation);
	setData(response.data.data.Designation);


	setLoading(false);
	})
	.catch((error) => {
	setError(error.message);
	setLoading(false);
	});
	}, []);


useEffect(() => {
handleUpdate();
}, []);

var elements = [];
for (var i = 1; i <= datacount.total_page; i++) {
elements.push(i);
}

//   for(var i=1;i<=datacount.total_page;i++){
// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
// 	  {i}
//   </a></li>);
// }

//console.log(elements)

//   const [currentPage,setCurrentPage]= useState(1);
const recordsPerPage = 10;

const lastIndex = currentPage * recordsPerPage;
const firstIndex = lastIndex - recordsPerPage;
const records = data.slice(firstIndex, lastIndex);
const npage = Math.ceil(data.length / recordsPerPage);
const numbers = [...Array(npage + 1).keys()].slice(1);




// const paginate= (page) => setCurrentPage(page);

const handleUpdate = async (designation_id) => {

axios.get(API_BASE_URL + '/showdesignation/' + designation_id, {
headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
})
.then(res1 => setUser(res1.data))
.catch(err => console.log(err))
};


const handlePagination = async (numpage) => {
// alert('hi');
// alert(numpage);
axios.get(API_BASE_URL + '/fetchurl?per_page=10&page_num=' + numpage, {
headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
})
.then(res1 => setData(res1.data))
.catch(err => console.log(err))
};

//    useEffect(() => {
// 	handlePagination(1);
//   }, []);


const handleSubmit = async (e) => {

e.preventDefault();
// setError(null);
// setLoading(true);
// e.preventDefault();
axios.post(API_BASE_URL + '/add_designation', formData, {
headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
}).then(response => {
// 	console.log(response.data);
// 	console.log(response.data.message);
// })


var status = response.data.status;

if (status=='success')
{
toast.success(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});
setTimeout(() => {
window.location.reload(); // Reload the page after delay
}, 3000);

} 
else if (status=='error')
{
toast.error(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});
// setTimeout(() => {
//   window.location.reload(); // Reload the page after delay
// }, 3000);

}
}).catch(error => {

// console.log(error);
// console.log(error.response.data.message);
toast.error(error.response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});

});



};



const handleEditSubmit = (e) => {

e.preventDefault();

console.log(user);
// setError(null);
// setLoading(true);
// e.preventDefault();
axios.post(API_BASE_URL + '/updatedesignation', {designation_id: user.designation_id,  designation_name: user.designation_name, man_power: user.man_power,department_id:user.department_id }, {
headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
}).then(response => {
// console.log(response.data);
// // 	console.log(response.data.message);
//  })


var status = response.data.status;

if (status=='success')
{
toast.success(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});
setTimeout(() => {
window.location.reload(); // Reload the page after delay
}, 3000);

} 
else if (status=='error')
{
toast.error(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});
// setTimeout(() => {
//   window.location.reload(); // Reload the page after delay
// }, 3000);

}
}).catch(error => {

// console.log(error);
// console.log(error.response.data.message);
toast.error(error.response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});

});

};

const textOnly =(e)=>{
    // alert(e.target.value.replace(/[^A-Za-z]/g, ''))
setFormData({
    ...formData,
    ['designation_name']: e.target.value.replace(/[^A-Za-z]/g, ''),
    });
}




return (
<>


<div>
<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<div className="container-fluid">

<ToastContainer />
<h3 className="card-title" style={{ color: '#e96827' }}> Add Designation </h3>

<form onSubmit={handleSubmit}>
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-body">
<div className="row clearfix">


        <div className="col-lg-4 col-md-12">
        <div className="form-group">

        <label>Company</label><span className="form-required">*</span>

        <Select
        defaultValue={formData.company_id}
        name="company_id"
        onChange={handleSelectChange} placeholder=' Company Name'
        options={setcmp}
        />
        </div>

        </div>

        <div className="col-lg-4 col-md-12">
        <div className="form-group">
        <label>Department</label><span className="form-required">*</span>
        <Select
        defaultValue={formData.department_id}
        name="department_id"
        onChange={handleSelect} placeholder=' Department Name'
        options={setdept}
        />

        </div>
        </div>
<div className="col-lg-4 col-md-12">
<div className="form-group">
<label>Designation Name</label><span className="form-required">*</span>


<div className="form-group">
<input type="text" onChange={textOnly}  className="form-control" name="designation_name" value={formData.designation_name}
	/*onChange={handleChange} */ placeholder="Designation Name" />
</div>


</div>
</div>


<div className="col-lg-4 col-md-12">
<div className="form-group">
<label>Man Power</label><span className="form-required">*</span>


<div className="form-group">
<input type="number" className="form-control" name="man_power" value={formData.	man_power}
	onChange={handleChange} placeholder="Man Power" />
</div>


</div>
</div>




</div>
<button type="submit" className="btn btn-round btn-primary">
Save
</button>

</div>

</div>


</div>

</form>

</div>
</div>


<div className="section-body">
<div className="container-fluid">
<div className="tab-content">
<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
<div className="card">
<div className="card-header">
<h3 className="card-title" style={{ color: '#e96827' }}>Designation List</h3>
<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>

<div className="input-group">

<select style={{
padding: '8px',
marginRight: '20px',
borderRadius: '4px',
border: '1px solid #ccc',
backgroundColor: '#BCD1DB', display: 'flex', justifyContent: 'left'
}}
id="rowsPerPage"
value={itemsPerPage}
onChange={handleRowsPerPageChange}
>
<option value={10}>10</option>
<option value={25}>25</option>
<option value={50}>50</option>
<option value={100}>100</option>
</select>

<div style={{ position: "relative", width: "300px" }}>

<input
type="text"
className="form-control form-control-sm"
placeholder="Search"
value={searchTerm}
onChange={handleSearch} 
style={{
width: "100%",
padding: "10px",
paddingRight: "30px", // Extra space for the clear icon
boxSizing: "border-box",
}}
// style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
/>

{searchTerm.length>0 && ( 
<span
onClick={clearInput}
style={{
position: "absolute",
top: "50%",
right:"10px",
transform: "translateY(-50%)",
cursor: "pointer",
color: "#aaa",
fontSize: "18px",
// marginLeft: '260px !important',

}}
>
✖
</span>
)}
</div>



</div>

</div>
</div>












<div className="card-body">
<div className="table-responsive">
<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
<thead>
<tr>
<th>S.No</th>
<th>Designation</th>
<th>Department</th>
<th>Man Power Needed</th>
<th>Man Power Available</th>
<th>Action</th>
</tr>
</thead>
<tbody>



{
filteredData.map((table, index) => {

return <tr key={index}>
<td className="d-flex">
<span
className="avatar avatar-blue"
data-toggle="tooltip"
data-original-title="Avatar Name"
>
{startIndex + index + 1}
</span>

</td>
<td>
<span>{table.designation_name}</span>
</td>
<td>
<span>{table.department_name}</span>
</td>
<td>
<span>{table.man_power}</span>
</td>
<td>
<span>{table.man_available}</span>
</td>

<td>



<button
type="button" onClick={() =>{ handleUpdate(table.designation_id);setUser(emptyUser)}}
className="btn btn-icon btn-sm"
title="Edit" data-toggle="modal"
data-target="#exampleEditModal"
>
<i className="fa fa-edit" />
</button>

</td>
</tr>


})
}

</tbody>
</table>
</div>



<nav aria-label="Page navigation">
<ul className="pagination mb-0 justify-content-end">
<li className="page-item"><button className="page-link"
key={'f'}
// style={{
//   backgroundColor: currentPage ===  1 && "lightgreen",
// }}
onClick={() => paginate(1)}
>
First
</button></li>

{Array.from(
{ length: Math.ceil(filteredItems.length / itemsPerPage) },
(_, index) => (
<li className="page-item">
<button className="page-link"
key={index + 1}
// style={{
//   backgroundColor: currentPage === index + 1 && "lightgreen",
// }}
onClick={() => paginate(index + 1)}
>
{index + 1}
</button></li>
)
)}

<li className="page-item">
<button className="page-link"
key={'l'}
// style={{
//   backgroundColor: currentPage ===  Math.ceil(filteredItems.length / itemsPerPage) && "lightgreen",
// }}
onClick={() => paginate(Math.ceil(filteredItems.length / itemsPerPage))}
>
Last
</button></li>






</ul>
</nav>









</div>
</div>
</div>


</div>
</div>
</div>

</div>
</div>





<div
className="modal fade"
id="exampleModal"
tabIndex={-1}
role="dialog"
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>

</div>




<div
className="modal fade"
id="exampleEditModal"
tabIndex={-1}
role="dialog"
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>
<form onSubmit={handleEditSubmit}>
<div className="modal-dialog" role="document">
<div className="modal-content">
<div className="modal-header">
<h5 className="modal-title" id="exampleModalLabel">
Edit Designation
</h5>
<button type="button" className="close" data-dismiss="modal" aria-label="Close">
<span aria-hidden="true">×</span>
</button>
</div>
<div className="modal-body">
<div className="row clearfix">
<div className="col-md-6 col-sm-6">
<div className="form-group">
<label className="form-label">Designation Name  <span className="form-required">*</span></label>
<input type="text" className="form-control" name="designation_name" value={user.designation_name}
onChange={handelInput} placeholder="Designation Name" />
</div>
</div>

{/* <div className="col-md-6 col-sm-6">
        <div className="form-group">
        <label>Department</label><span className="form-required">*</span>
        <Select
        defaultValue={user.department_id}
        name="department_id"
        onChange={handelInput} placeholder=' Department Name'
        options={setdept}
        />

        </div>
        </div> */}
<div className="col-md-6 col-sm-6">
<label className="form-label">Department Name  <span className="form-required">*</span></label>

<Select
        name="department_id"
        value={setdept.find((item) => item.value === user.department_id) || null}
        onChange={(selected) =>
            setUser({
                ...user,
                department_id: selected.value,
            })
        }
        options={setdept}
        placeholder="Search Department"
        isSearchable={true}
        className="mt-1"
    />

					</div> 
        <div className="col-md-6 col-sm-6">
<div className="form-group">
<label className="form-label">Man Power<span className="form-required">*</span></label>
<input type="number" className="form-control" name="man_power" value={user.man_power}
onChange={handelInput} placeholder="Designation Name" />
</div>
</div>

</div>
</div>
<div className="modal-footer">
<button type="button" className="btn btn-secondary" data-dismiss="modal">
Close
</button>
<button type="submit" className="btn btn-primary">
Save changes
</button>
</div>
</div>
</div>

</form>

</div>




<div
className="modal fade"
id="exampleEditModal1"
tabIndex={-1}
role="dialog"
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>


</div>






</>
);

}



const mapStateToProps = (state) => ({
fixNavbar: state.settings.isFixNavbar,
statisticsOpen: state.settings.isStatistics,
statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
statisticsAction: (e) => dispatch(statisticsAction(e)),
statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(Designation);